import React, { Dispatch, SetStateAction, useState } from "react"
import tw from "twin.macro"
import { useTranslation } from "next-i18next"
import Textarea, { MaxLength } from "../formElements/textarea"
import { Button } from "../formElements/button"
import { UpdateQuestionSetFlaggedMutationFn } from "../../graphql/generated/graphql"
import { LottieAnimation } from "../lottieAnimation"
import animationData from "../../assets/question/paper_airplane_horizontal.json"
import { isMobile } from "react-device-detect"

interface FlagModalProps {
  refetchQuestion: () => Promise<Record<string, any>>
  setShowFlagModal: Dispatch<SetStateAction<boolean>>
  questionId: string
  setFlagged: UpdateQuestionSetFlaggedMutationFn
}
export const FlagModal = ({ setShowFlagModal, questionId, setFlagged, refetchQuestion }: FlagModalProps) => {
  const { t } = useTranslation("question")
  const [flaggedMessage, setFlaggedMessage] = useState("")
  const [processing, setProcessing] = useState(false)

  const handleSubmit = async () => {
    setProcessing(true)
    const response = await setFlagged({ variables: { questionId, flaggedMessage } })
    if (response.data) {
      setProcessing(false)
      setShowFlagModal(false)
      await refetchQuestion()
    }
  }
  return (
    <>
      {processing ? (
        <div tw="flex flex-col items-center text-center">
          <h1 tw="text-lg font-bold">{t("flag.thank_you")}</h1>
          <div tw="flex justify-center">
            <LottieAnimation
              data-chromatic="ignore"
              width={isMobile ? "234px" : "300px"}
              height="auto"
              animationData={animationData}
            />
          </div>
          <p tw="text-sm">{t("flag.review")}</p>
        </div>
      ) : (
        <div tw="flex flex-col items-center text-center space-y-4">
          <h1 tw="text-lg font-bold">{t("flag.title")}</h1>
          <p tw="text-sm font-bold" dangerouslySetInnerHTML={{ __html: t("flag.description") }} />
          <Textarea
            name="reporting-question"
            value={flaggedMessage}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => setFlaggedMessage(event.target.value)}
            maxLength={MaxLength.Max280}
            placeholder={`${t("flag.placeholder")}`}
          />
          <span tw="text-xs text-base-3 self-start">{t("flag.note")}</span>
          <Button
            dataTestId="submit-button"
            twStyle={tw`w-full`}
            action={`${t("flag.submit")}`}
            onClickAsync={async () => await handleSubmit()}
            isDisabled={!flaggedMessage}
          />
        </div>
      )}
    </>
  )
}
